export default "__VITE_ASSET__e04c248b__"